// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-3uShKNh","small":"small-tmfsGeT","medium":"medium-12S6YEi","large":"large-tlZtAV4"};